<script setup lang="ts">
import { computed, defineProps } from 'vue';

const props = defineProps<{
  variant: string | null;
}>();

const VARIANTS = {
  gray: 'text-gray-500',
  yellow: 'text-brand-500',
  green: 'text-success-500',
  blue: 'text-blue-300',
  pink: 'text-pink-300',
  orange: 'text-orange-300',
  light_blue: 'text-sky-300',
} as const;

function isValidVariant(variant: string): variant is keyof typeof VARIANTS {
  return variant in VARIANTS;
}

const textColor = computed(() => {
  if (props.variant === null) {
    return VARIANTS.gray;
  }

  if (isValidVariant(props.variant)) {
    return VARIANTS[props.variant];
  }

  return VARIANTS.gray;
});
</script>

<template>
  <span :class="textColor">
    <slot></slot>
  </span>
</template>
